import { useState, useEffect } from 'react';
import { Link } from 'components/Link';
import { projects } from 'constants/projects';
import blackThemeLogo from 'assets/images/black-theme.svg';
import whiteThemeLogo from 'assets/images/white-theme.svg';
import 'index.scss';

export default function App() {
  const [isDark, setIsDark] = useState(() => {
    if (typeof window !== 'undefined' && window.matchMedia) {
      return window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    return false;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      setIsDark(e.matches);
      document.documentElement.setAttribute('data-theme', e.matches ? 'dark' : 'light');
    };

    document.documentElement.setAttribute('data-theme', mediaQuery.matches ? 'dark' : 'light');

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return (
    <div className='container'>
      <main className='main'>
        <div className='brand-logo'>
          <picture>
            <source srcSet={blackThemeLogo} media='(prefers-color-scheme: dark)' />
            <img src={isDark ? blackThemeLogo : whiteThemeLogo} alt='Sate logo' />
          </picture>
        </div>
        <h1 className='title'>Sate</h1>
        <h2 className='subtitle'>Building software from Kyiv</h2>
        <h3 className='description'>
          We're a team of software engineers passionate about creating and building solutions that make a difference
        </h3>
        <h4 className='action'>Get in touch</h4>
        <a className='button' href='mailto:sate.kgd@gmail.com'>
          Contact us
        </a>
        <ul className='projects'>
          {projects.map(({ id, name, logo, link, nowrap }) => (
            <li className='project' key={id}>
              <a
                href={link}
                target='_blank'
                rel='noreferrer noopener'
                style={{ whiteSpace: nowrap ? 'nowrap' : 'normal' }}
              >
                <img src={logo} alt={name} />
                <h5>{name}</h5>
              </a>
            </li>
          ))}
          <li className='project'>
            <div className='soon'>?</div>
            <span>soon</span>
          </li>
        </ul>
      </main>
      <footer className='footer'>
        <p>
          Currently building <Link text='e-phan' href='https://e-phan.com' external />
        </p>
        <p>Sate © {new Date().getFullYear()}</p>
      </footer>
    </div>
  );
}
